const cn = (...args: any[]) => args.filter(Boolean).map(String).join(" ");

export default cn;
